import forEach from '../util/for-each'
import hasClass from '../util/has-class'

const tabs = document.querySelectorAll('.js-tab')

/**
 * activate tab content when given an activate target node and a tab group id
 *
 * @param {any} tabContentNode
 * @param {String} groupId
 * @param {any} clickedTab
 */
function activateTab (tabContentNode, groupId, clickedTab) {
    const tabContentGroup = document.querySelectorAll(`.js-tabContent[data-tab-group=${groupId}]`)
    const tabEls = document.querySelectorAll(`.js-tab[data-tab-group-id=${groupId}]`)

    // reset all (targeted) tab content to hidden state
    forEach(tabContentGroup, (tabContent) => {
        tabContent.classList.remove('is-active')
        tabContent.classList.remove('is-shown')
    })

    // reset all (targeted) tab to default state
    forEach(tabEls, (tabEl) => {
        tabEl.classList.remove('is-active')
    })

    // show active tab styles
    clickedTab.classList.add('is-active')

    // display: block; the target tab content
    tabContentNode.classList.add('is-active')

    // Nested RAF for sequence animation
    window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
            // opacity: 1; the taget tab content
            tabContentNode.classList.add('is-shown')
        })
    })
}

if (tabs) {
    forEach(tabs, (tab) => {
        tab.addEventListener('click', (e) => {
            const targetId = tab.dataset.tabId
            const targetGroupId = tab.dataset.tabGroupId
            const targetTabContent = document.querySelector(`.js-tabContent[data-tab-id=${targetId}]`)

            // if the targeted tab is not already active,  activate it
            if (!hasClass(targetTabContent, 'is-active')) {
                activateTab(targetTabContent, targetGroupId, tab)
            }
        })
    })
}
